import { useFeathersClient } from '@strac/react-client-feathers'
import { useCallback } from 'react'

const useSplunkLogger = () => {
  const client = useFeathersClient();
  return useCallback(
    (error: any, moreInfo = {}) =>
      client.service('splunk').create({
        source: 'client',
        environment: import.meta.env.MODE,
        error: error.message,
        moreInfo
      }),
    [client]
  )
}

export default useSplunkLogger
